<template>
  <div v-if="hasCardData" class="sitter-card-box lg:w-1/2">
    <div class="mx-16 mt-16 mb-24 md:mb-56">
      <p class="flex text-body mb-12">
        What your profile looks like to families
        <curving-arrow-icon class="relative bottom-[-10px] ml-4" />
      </p>
      <SitterCard
        :name="sitterCardName"
        :yearsExperience="yearsExperience"
        :city="city"
        :stateAbbr="stateAbbr"
        :description="bio"
        :idv="idv"
        :badges="badges"
        :minRate="minRate"
        :maxRate="maxRate"
        :photoUploadAvatar="!hasPhoto"
        :photoUrl="photoUrl"
        customClasses="max-w-[375px]"
      />
    </div>
  </div>
</template>

<script lang="ts">
import SitterCard from '@/components/sitter_card/SitterCard.vue';
import CurvingArrowIcon from '@/graphics/icons/CurvingArrowIcon.vue';
import { IDV, Badge } from '@/components/sitter_badge_list/__types__/SitterBadgeListTypes';

export default {
  name: 'ProfileCompletePreview',
  components: {
    SitterCard,
    CurvingArrowIcon,
  },
  props: {
    hasCardData: {
      type: Boolean,
      required: true,
    },
    sitterCardName: {
      type: String,
      required: true,
    },
    yearsExperience: {
      type: Number,
      required: true,
    },
    city: {
      type: String,
      required: true,
    },
    stateAbbr: {
      type: String,
      required: true,
    },
    bio: {
      type: String,
      required: true,
    },
    idv: {
      type: Object as () => IDV,
      required: true,
    },
    badges: {
      type: Array as () => Badge[],
      required: true,
    },
    minRate: {
      type: Number,
      required: true,
    },
    maxRate: {
      type: Number,
      required: true,
    },
    hasPhoto: {
      type: Boolean,
      required: true,
    },
    photoUrl: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.sitter-card-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #ffeef8;
  background-image: url('@/images/account/pink_swoop.svg');
  background-size: 100% 90%;
  background-repeat: no-repeat;
  background-position: bottom;
  min-height: 349px;
  border-radius: 4px;
}
</style>
